import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useLanguage } from '../../../i18n/LanguageContext';
//import { useAudio } from '../../../contexts/AudioContext';
//import SimpleAudioPlayer from './SimpleAudioPlayer';
import YouTubeAudioPlayer from './YouTubeAudioPlayer.js';
import { extractYouTubeID } from '../../../Utils/utilities.js';

const LyricsModal = ({ isOpen, onClose, music, lyrics }) => {
  const { language } = useLanguage();
  
  const [lyricsLanguage, setLyricsLanguage] = useState(language);

  useEffect(() => {
    if (isOpen) {
      setLyricsLanguage(language);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, language]);

  const handleLanguageToggle = () => {
    setLyricsLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };


  // const handlePlayPause = () => {
  //   if (isPlaying && currentMusic?.id === music?.id) {
  //     pauseMusic();
  //   } else {
  //     playMusic(music);
  //   }
  // };

  if (!isOpen || !music) return null;

  const currentLyrics = lyricsLanguage === 'hi' ? lyrics?.hindi_lyrics : lyrics?.english_lyrics;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 z-[1000] flex items-center justify-center p-4 pb-20">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-red-500 p-6 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src={music.thumbnail} 
                alt={music.title}
                className="w-16 h-16 rounded-lg object-cover"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/64x64/FF6B35/FFFFFF?text=🎵';
                }}
              />
              <div>
                <h2 className="text-2xl font-bold">{music.title}</h2>
                <p className="text-orange-100 capitalize">{music.type}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-white hover:bg-opacity-20 rounded-full transition-colors"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>
        </div>

        {/* Player Controls */}
        {/* <div className="bg-gray-50 p-4">
          <div className="flex items-center justify-center space-x-4">
            <button
              onClick={handlePlayPause}
              className={`p-4 rounded-full transition-colors ${
                isPlaying && currentMusic?.id === music?.id
                  ? 'bg-orange-600 text-white'
                  : 'bg-orange-500 text-white hover:bg-orange-600'
              }`}
            >
              {isPlaying && currentMusic?.id === music?.id ? <FaPause className="text-xl" /> : <FaPlay className="text-xl" />}
            </button>
            
            <div className="flex items-center space-x-2">
              <button
                onClick={toggleMute}
                className="p-2 text-gray-600 hover:text-gray-800 transition-colors"
              >
                {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
              </button>
              <span className="text-sm text-gray-600">Volume</span>
            </div>
          </div>
        </div> */}

        {/* <SimpleAudioPlayer
          videoId={music?.yt_link}
          isPlaying={isPlaying && currentMusic?.id === music?.id}
          onPlay={() => playMusic(music)}
          onPause={pauseMusic}
          onTimeUpdate={handleTimeUpdate}
          onDurationChange={handleDurationChange}
          onEnded={handleEnded}
          volume={volume}
        /> */}

        <YouTubeAudioPlayer
          videoId={extractYouTubeID(music?.yt_link)}
        />

        {/* Language Toggle */}
        <div className="bg-white border-b p-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-800">Lyrics</h3>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-600">Language:</span>
              <button
                onClick={handleLanguageToggle}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  lyricsLanguage === 'en' 
                    ? 'bg-orange-500 text-white' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                English
              </button>
              <button
                onClick={handleLanguageToggle}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  lyricsLanguage === 'hi' 
                    ? 'bg-orange-500 text-white' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                हिंदी
              </button>
            </div>
          </div>
        </div>

        {/* Lyrics Content */}
        <div className="p-6 max-h-96 overflow-y-auto">
          {currentLyrics ? (
            <div className="prose prose-lg max-w-none">
              <pre className="whitespace-pre-wrap font-sans text-gray-800 leading-relaxed">
                {currentLyrics}
              </pre>
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">
                {lyricsLanguage === 'hi' ? 'हिंदी गीत उपलब्ध नहीं है' : 'English lyrics not available'}
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-50 p-4 text-center">
          <p className="text-sm text-gray-600">
            {lyricsLanguage === 'hi' 
              ? 'भक्ति संगीत का आनंद लें' 
              : 'Enjoy the devotional music'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default LyricsModal;
